import React from 'react';
import "./overview.css";
import stick from "../../assets/images/sticky-note.png";
import calendar from "../../assets/images/calendar.png";
import plus from "../../assets/images/plus.png";
import check from "../../assets/images/check-circle.png"
import room from "../../assets/images/room.png"
import { useLocation, useNavigate } from "react-router";
import { useState } from 'react';
import {  updateNote, deleteNotes, fetchCurrentOverViewNotes, fetchCurrentStaysNotes, fetchCurrentStopNotes } from '../../redux/features/addNotesSlice';
import { useDispatch, useSelector } from 'react-redux';
import deleteicon from "../../assets/images/icons/deleteicon.svg";
import NotesComponent from '../notes/notesComponent';
import { useEffect } from 'react';

export default function Tabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedTab = location?.state?.type ? location.state.type : 1;
  console.log(location?.state?.type,'selectedTab')
  const [toggleTabs, setToggleTabs] = useState(selectedTab);

  const overviewNotes = useSelector(fetchCurrentOverViewNotes)
  const stayNotes = useSelector(fetchCurrentStaysNotes)
  const stopNotes = useSelector(fetchCurrentStopNotes)

  const dispatch = useDispatch()
  const toggleTab = (index) => {
    setToggleTabs(index);
  }



    
  return (
    <div>
      <div className="overview-btns">
        <button className={toggleTabs === 1 ? "tabs active-tabs" : "tabs"}
              onClick={() => toggleTab(1)}>Overview</button>
        <button className={toggleTabs === 2 ? "tabs active-tabs" : "tabs"}
          onClick={() => toggleTab(2)}>Stays</button>
        <button className={toggleTabs === 3 ? "tabs active-tabs" : "tabs"}
          onClick={() => toggleTab(3)}>Stops</button>
       </div>
          
      <div className={toggleTabs === 1 ? "content-active" : "content"}>
        <div className="overview-trips-content">
          <button onClick={()=>navigate("addnewplaces")} className="place-btn">+ Add new place</button>
          <div className='note-area'>
         <NotesComponent notes = {overviewNotes}/>
           </div>
          
          <div className="note" style={{margin:"10px 0 0"}}>
            <img src={stick} alt="stick"  />
            <button className="note-btn" onClick={()=>navigate("add-notes",{state:{type:toggleTabs}})}>Add note</button>
        </div>
       </div>
          </div>
          <div className={toggleTabs === 2 ? "content-active" : "content"}>
              <div className='stays-trip-top'>
                  <p style={{fontSize:"17px", fontWeight:"600", margin:"0"}}>Jimbaran</p>
                  <div style={{display:"flex", alignItems:"center"}}>
                      <img src={calendar} alt="calendar" />
                      <p style={{fontSize:"15px", fontWeight:"400", margin:"0 5px"}}>Oct 4-5</p>
                  </div>
              </div>
            <div className="stays-trip-content">
                  <p style={{ fontSize: "15px", margin: "0 0 16px" }}>Add stays</p>
                  <div className="stays-trip-btn">
                      <button className="stays-list-btn">From hotel list</button>
                      <button className="stays-custom-btn">+ Custom hotel</button>
                  </div>
                  <div className='note-area'>
                  <NotesComponent notes = {stayNotes}/>
           </div>
                  <div className="note" style={{margin:"10px 0 0"}}>
                   <img src={stick} alt="stick" />
                   <button className="note-btn" onClick={()=>navigate("add-notes",{state:{type:toggleTabs}})}>Add note</button>
                  </div>
                  <div style={{ borderBottom: "1px solid #CDD0E1", margin: "2rem 0 0" }}></div>
                  <div className="note">
                   <img src={plus} alt="stick" />
                   <button className="note-btn">Add suggested stays</button>
                  </div>
            </div> 
          </div>
          <div className={toggleTabs === 3 ? "content-active" : "content"}>
          <div className='stays-trip-top'>
                  <p style={{fontSize:"17px", fontWeight:"600", margin:"0"}}>Day 1: <span style={{fontSize:"15px", fontWeight:"400", margin:"0"}}>Jimbaran</span></p>
                  <div style={{display:"flex", alignItems:"center"}}>
                      <img src={calendar} alt="calendar" />
                      <p style={{fontSize:"15px", fontWeight:"400", margin:"0 5px"}}>Oct 4</p>
                  </div>
              </div>
              <div className="stays-trip-content">
                  <div style={{display:"flex", alignItems:"center", gap:"5px", marginBottom:"1.5rem"}}>
                      <img src={check} alt="check-icon" />
                      <img src={room} alt="room-icon" />
                      <p style={{ fontSize: "15px", margin: "0" }}>Watermark Hotel & Spa</p>
                  </div>
                  <p style={{ fontSize: "15px", margin: "0 0 16px" }}>Add stops</p>
                  <div className="stays-trip-btn">
                      <button className="stays-list-btn" style={{width:"48.5%"}}>From list</button>
                      <button className="stays-custom-btn" style={{width:"48.5%"}}>+ Custom card</button>
                  </div>
                  <div className='note-area'>
                  <NotesComponent notes = {stopNotes}/>
           </div>
          
          <div className="note" style={{margin:"10px 0 0"}}>
            <img src={stick} alt="stick"  />
            <button className="note-btn" onClick={()=>navigate("add-notes",{state:{type:toggleTabs}})}>Add note</button>
        </div>
                  <div style={{ borderBottom: "1px solid #CDD0E1", margin: "2rem 0 0" }}></div>
                  <div className="note">
                   <img src={plus} alt="stick" />
                   <button className="note-btn">Add similar items</button>
                  </div>
            </div> 
      </div>    
    </div>
  )
}
